import { SignUpParams } from './SignUpParams';

// The hop back to /login has to preserve everything the sign-up surface was given, or a visitor who
// realises they already have an account loses their plan, their destination, and any live WorkOS
// Connect flow. The login page reads the Connect handle under its WorkOS-supplied snake_case name.
export function buildLoginHref({ planCode, redirectAfterRegister, externalAuthId }: SignUpParams): string {
    const params = new URLSearchParams();
    if (planCode) {
        params.set('planCode', planCode);
    }
    if (redirectAfterRegister) {
        params.set('redirectAfterLogin', redirectAfterRegister);
    }
    if (externalAuthId) {
        params.set('external_auth_id', externalAuthId);
    }

    const query = params.toString();
    return query ? `/login?${query}` : '/login';
}
